"use client";
import LearnerTestimonials from "@/components/CourseContent/LearnerTestimonials";
import { AuthorStatementTestimonial } from "@/components/CourseContent/LearnerTestimonials/index";
import useTranslations from "@/i18n/useTranslations";

const DegreeLearnerTestimonials = ({
  learnerTestimonials,
}: {
  learnerTestimonials: string | AuthorStatementTestimonial[];
}) => {
  const t = useTranslations("Program");
  return (
    <div className="container pb-16">
      <LearnerTestimonials
        testimonials={learnerTestimonials}
        trackEvents={true}
        title={t("learnerTestimonials")}
      />
    </div>
  );
};

export default DegreeLearnerTestimonials;
